function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icomoon-ignore"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M268.94 401.613l-112.008 85.627c-25.349 19.378-61.825 1.276-61.877-30.586l-0.096-58.316c-52.153-12.541-90.748-59.63-90.748-115.572v-147.145c0-65.615 53.028-118.846 118.49-118.846h266.601c65.462 0 118.49 53.231 118.49 118.846v147.145c0 65.615-53.028 118.846-118.49 118.846h-120.36zM145.373 432.689l99.753-76.258c4.391-3.357 9.764-5.175 15.292-5.175h128.882c37.606 0 68.132-30.642 68.132-68.488v-147.145c0-37.846-30.525-68.488-68.132-68.488h-266.601c-37.606 0-68.132 30.642-68.132 68.488v147.145c0 37.134 29.436 67.452 66.224 68.462 13.616 0.374 24.466 11.507 24.488 25.128l0.093 56.332z"
});

var SvgComment = function SvgComment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comment.028f4658.svg";
export { ForwardRef as ReactComponent };